import React from "react";
import { useTranslate } from "./TranslationText";

export default function ContactInquirySection() {
  const { translate } = useTranslate();

  return (
    <div className="col-12 mt-3 mb-main">
      <div className="p-main bg-white border-15 p-3">
        <p className="mb-3">
          {translate("web.forInquiriesContactUs", "For inquiries, please contact us:")}
        </p>
        <div className="d-flex flex-column gap-2">
          <div className="d-flex align-items-center gap-2">
            <i className="fa fa-envelope C89C66 w-unset"></i>
            <span>
              <strong>{translate("web.email", "Email")}:</strong>{" "}
              <a href="mailto:marketing@eahs.ae" className="linkinsidealinetable">marketing@eahs.ae</a>
            </span>
          </div>
          <div className="d-flex align-items-center gap-2">
            <i className="fa fa-phone C89C66 w-unset"></i>
            <span>
              <strong>{translate("web.mobile", "Mobile")}:</strong>{" "}
              <a href="tel:+971506602559" dir="ltr" className="linkinsidealinetable">+971 50 660 2559</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
